<template>
  <div class="news_list">
    <list :list='news' :router_name='router_name'></list>
    <div v-show="news.length == 0 && nodata == false" style="margin:40px auto;font-size:21px;text-align: center;">
      <img src="../../assets/loading.gif">
    </div>
    <div v-show="nodata" style="margin:40px auto;font-size:21px;text-align: center;">目前無最新消息</div>
    <moreButton button_text="返回首頁" button_href="/"></moreButton>
  </div>
</template>
<script>
import list from '@/components/list/list'
import MoreButton from '@/components/index/MoreButton'
export default {
  components: {
    'list': list,
    'moreButton': MoreButton,

  },
  data() {
    return {
      router_name: 'news_page',
      news: [
      ],
      nodata: false,
    }
  },
  computed: {
  },
  created() {
    var vm = this;
    var news_api = process.env.VUE_APP_API + 'tlweb/news?online=1'
    this.axios.get(news_api)
      .then(function (response) {
        vm.news = response.data.data.data

        for (var deleteHtmlTag = 0; deleteHtmlTag < vm.news.length; deleteHtmlTag++) {
          // console.log(vm.news[deleteHtmlTag].content);
          vm.news[deleteHtmlTag].content = vm.news[deleteHtmlTag].content.replace(/<[^>]+>|&[^;]+;/g, "").trim();
          // /<[^>]+>|&[^>]+;/g
          if (vm.news[deleteHtmlTag].title.length > 80) {
            vm.news[deleteHtmlTag].title = vm.news[deleteHtmlTag].title.slice(0, 80) + "...";
          } else {
            vm.news[deleteHtmlTag].title = vm.news[deleteHtmlTag].title;
          }

          if (vm.news[deleteHtmlTag].content.length > 80) {
            vm.news[deleteHtmlTag].content = vm.news[deleteHtmlTag].content.slice(0, 80) + "...";
          } else {
            vm.news[deleteHtmlTag].content = vm.news[deleteHtmlTag].content;
          }
          // console.log(vm.news[deleteHtmlTag].content);
          // console.log(vm.news[deleteHtmlTag].content.length);
        }
        // setTimeout(() => {
        if (vm.news.length == 0) {
          vm.nodata = true
        } else {
          vm.nodata = false
        }
        // } ,2500);
      })
      .catch(function (error) {
        console.log(error);
      });
  },
}
</script>
<style></style>
